import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { ForgotPasswordContainer } from './ForgotPassword.styled';
import { AuthFlowLayout } from 'components/v2/Layouts/AuthFlowLayout/AuthFlowLayout';
import { pageUrl } from 'utilities/pageUrl';

import { ForgotPasswordForm } from './ForgotPasswordForm';
import { FormType } from './ForgotPasswordForm.types';

export const ForgotPassword = () => {
  const [formType, setFormType] = useState<FormType>('request_code');
  const navigate = useNavigate();

  const onGoBack = () => {
    window.scrollTo(0, 0);
    formType === 'request_code'
      ? navigate(pageUrl.login(), { replace: true })
      : setFormType('request_code');
  };

  return (
    <ForgotPasswordContainer>
      <AuthFlowLayout
        title={getTitle(formType)}
        renderMainContent={() => {
          return (
            <ForgotPasswordForm
              onSuccessfulReset={() => navigate(pageUrl.login(), { replace: true })}
              onGoBack={onGoBack}
              handleUnconfirmed={email => {
                navigate(pageUrl.emailAddressVerification(), {
                  state: {
                    email,
                    forgotPassword: true
                  }
                });
              }}
              formType={formType}
              updateFormType={formType => setFormType(formType)}
            />
          );
        }}
      />
    </ForgotPasswordContainer>
  );
};

const getTitle = (formType: FormType) =>
  formType === 'request_code' ? 'Forgot Your Password?' : 'Create New Password';
